/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Lutely API
 * Lutely API
 * OpenAPI spec version: local
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  CreateCreatorDto,
  CreatorsControllerCreatorsList200,
  CreatorsControllerCreatorsListParams,
  CreatorsControllerFindAllCreators200,
  CreatorsControllerFindAllCreatorsParams,
  CreatorsControllerTopCreators200,
  CreatorsControllerTopCreatorsParams,
  CreatorsControllerUploadImageBody,
  DetailCreatorDto,
  GrantArtistAccessDto,
  GrantArtistAccessResponseDto,
  UpdateCreatorDto,
} from ".././dtos";

import { apiRequest } from "../../api-request";
import type { ErrorType, BodyType } from "../../api-request";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Create a creator
 */
export const creatorsControllerCreateCreator = (
  createCreatorDto: BodyType<CreateCreatorDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DetailCreatorDto>(
    {
      url: `/creators`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCreatorDto,
      signal,
    },
    options,
  );
};

export const getCreatorsControllerCreateCreatorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerCreateCreator>>,
    TError,
    { data: BodyType<CreateCreatorDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerCreateCreator>>,
  TError,
  { data: BodyType<CreateCreatorDto> },
  TContext
> => {
  const mutationKey = ["creatorsControllerCreateCreator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerCreateCreator>>,
    { data: BodyType<CreateCreatorDto> }
  > = (props) => {
    const { data } = props ?? {};

    return creatorsControllerCreateCreator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerCreateCreatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerCreateCreator>>
>;
export type CreatorsControllerCreateCreatorMutationBody =
  BodyType<CreateCreatorDto>;
export type CreatorsControllerCreateCreatorMutationError = ErrorType<unknown>;

/**
 * @summary Create a creator
 */
export const useCreatorsControllerCreateCreator = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerCreateCreator>>,
      TError,
      { data: BodyType<CreateCreatorDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerCreateCreator>>,
  TError,
  { data: BodyType<CreateCreatorDto> },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerCreateCreatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Find all creators for a logged user
 */
export const creatorsControllerFindAllCreators = (
  params?: CreatorsControllerFindAllCreatorsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CreatorsControllerFindAllCreators200>(
    { url: `/creators`, method: "GET", params, signal },
    options,
  );
};

export const getCreatorsControllerFindAllCreatorsQueryKey = (
  params?: CreatorsControllerFindAllCreatorsParams,
) => {
  return [`/creators`, ...(params ? [params] : [])] as const;
};

export const getCreatorsControllerFindAllCreatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerFindAllCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreatorsControllerFindAllCreatorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>
  > = ({ signal }) =>
    creatorsControllerFindAllCreators(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CreatorsControllerFindAllCreatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>
>;
export type CreatorsControllerFindAllCreatorsQueryError = ErrorType<unknown>;

export function useCreatorsControllerFindAllCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CreatorsControllerFindAllCreatorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCreatorsControllerFindAllCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerFindAllCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCreatorsControllerFindAllCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerFindAllCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Find all creators for a logged user
 */

export function useCreatorsControllerFindAllCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerFindAllCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerFindAllCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCreatorsControllerFindAllCreatorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a creator
 */
export const creatorsControllerUpdateCreator = (
  updateCreatorDto: BodyType<UpdateCreatorDto>,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<DetailCreatorDto>(
    {
      url: `/creators`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateCreatorDto,
    },
    options,
  );
};

export const getCreatorsControllerUpdateCreatorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>,
    TError,
    { data: BodyType<UpdateCreatorDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>,
  TError,
  { data: BodyType<UpdateCreatorDto> },
  TContext
> => {
  const mutationKey = ["creatorsControllerUpdateCreator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>,
    { data: BodyType<UpdateCreatorDto> }
  > = (props) => {
    const { data } = props ?? {};

    return creatorsControllerUpdateCreator(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerUpdateCreatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>
>;
export type CreatorsControllerUpdateCreatorMutationBody =
  BodyType<UpdateCreatorDto>;
export type CreatorsControllerUpdateCreatorMutationError = ErrorType<unknown>;

/**
 * @summary Update a creator
 */
export const useCreatorsControllerUpdateCreator = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>,
      TError,
      { data: BodyType<UpdateCreatorDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerUpdateCreator>>,
  TError,
  { data: BodyType<UpdateCreatorDto> },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerUpdateCreatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary List creators with search and filtering
 */
export const creatorsControllerCreatorsList = (
  params?: CreatorsControllerCreatorsListParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CreatorsControllerCreatorsList200>(
    { url: `/creators/list`, method: "GET", params, signal },
    options,
  );
};

export const getCreatorsControllerCreatorsListQueryKey = (
  params?: CreatorsControllerCreatorsListParams,
) => {
  return [`/creators/list`, ...(params ? [params] : [])] as const;
};

export const getCreatorsControllerCreatorsListQueryOptions = <
  TData = Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerCreatorsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCreatorsControllerCreatorsListQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creatorsControllerCreatorsList>>
  > = ({ signal }) =>
    creatorsControllerCreatorsList(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CreatorsControllerCreatorsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerCreatorsList>>
>;
export type CreatorsControllerCreatorsListQueryError = ErrorType<unknown>;

export function useCreatorsControllerCreatorsList<
  TData = Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CreatorsControllerCreatorsListParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerCreatorsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCreatorsControllerCreatorsList<
  TData = Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerCreatorsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerCreatorsList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCreatorsControllerCreatorsList<
  TData = Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerCreatorsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary List creators with search and filtering
 */

export function useCreatorsControllerCreatorsList<
  TData = Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerCreatorsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerCreatorsList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCreatorsControllerCreatorsListQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Grant an artist their own login scoped to this creator's sub-account
 */
export const creatorsControllerGrantArtistAccess = (
  creatorId: string,
  grantArtistAccessDto: BodyType<GrantArtistAccessDto>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<GrantArtistAccessResponseDto>(
    {
      url: `/creators/${creatorId}/grant-access`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: grantArtistAccessDto,
      signal,
    },
    options,
  );
};

export const getCreatorsControllerGrantArtistAccessMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>,
    TError,
    { creatorId: string; data: BodyType<GrantArtistAccessDto> },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>,
  TError,
  { creatorId: string; data: BodyType<GrantArtistAccessDto> },
  TContext
> => {
  const mutationKey = ["creatorsControllerGrantArtistAccess"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>,
    { creatorId: string; data: BodyType<GrantArtistAccessDto> }
  > = (props) => {
    const { creatorId, data } = props ?? {};

    return creatorsControllerGrantArtistAccess(creatorId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerGrantArtistAccessMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>
>;
export type CreatorsControllerGrantArtistAccessMutationBody =
  BodyType<GrantArtistAccessDto>;
export type CreatorsControllerGrantArtistAccessMutationError =
  ErrorType<unknown>;

/**
 * @summary Grant an artist their own login scoped to this creator's sub-account
 */
export const useCreatorsControllerGrantArtistAccess = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>,
      TError,
      { creatorId: string; data: BodyType<GrantArtistAccessDto> },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerGrantArtistAccess>>,
  TError,
  { creatorId: string; data: BodyType<GrantArtistAccessDto> },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerGrantArtistAccessMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a creator
 */
export const creatorsControllerDeleteCreator = (
  creatorId: string,
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/creators/${creatorId}`, method: "DELETE" },
    options,
  );
};

export const getCreatorsControllerDeleteCreatorMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>,
    TError,
    { creatorId: string },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>,
  TError,
  { creatorId: string },
  TContext
> => {
  const mutationKey = ["creatorsControllerDeleteCreator"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>,
    { creatorId: string }
  > = (props) => {
    const { creatorId } = props ?? {};

    return creatorsControllerDeleteCreator(creatorId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerDeleteCreatorMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>
>;

export type CreatorsControllerDeleteCreatorMutationError = ErrorType<unknown>;

/**
 * @summary Delete a creator
 */
export const useCreatorsControllerDeleteCreator = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>,
      TError,
      { creatorId: string },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerDeleteCreator>>,
  TError,
  { creatorId: string },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerDeleteCreatorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Upload a creator's profile picture or banner
 */
export const creatorsControllerUploadImage = (
  creatorId: string,
  imageType: "profile" | "banner",
  creatorsControllerUploadImageBody: BodyType<CreatorsControllerUploadImageBody>,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  const formData = new FormData();
  formData.append(`file`, creatorsControllerUploadImageBody.file);

  return apiRequest<void>(
    {
      url: `/creators/${creatorId}/images/${imageType}`,
      method: "POST",
      headers: { "Content-Type": "multipart/form-data" },
      data: formData,
      signal,
    },
    options,
  );
};

export const getCreatorsControllerUploadImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerUploadImage>>,
    TError,
    {
      creatorId: string;
      imageType: "profile" | "banner";
      data: BodyType<CreatorsControllerUploadImageBody>;
    },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerUploadImage>>,
  TError,
  {
    creatorId: string;
    imageType: "profile" | "banner";
    data: BodyType<CreatorsControllerUploadImageBody>;
  },
  TContext
> => {
  const mutationKey = ["creatorsControllerUploadImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerUploadImage>>,
    {
      creatorId: string;
      imageType: "profile" | "banner";
      data: BodyType<CreatorsControllerUploadImageBody>;
    }
  > = (props) => {
    const { creatorId, imageType, data } = props ?? {};

    return creatorsControllerUploadImage(
      creatorId,
      imageType,
      data,
      requestOptions,
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerUploadImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerUploadImage>>
>;
export type CreatorsControllerUploadImageMutationBody =
  BodyType<CreatorsControllerUploadImageBody>;
export type CreatorsControllerUploadImageMutationError = ErrorType<unknown>;

/**
 * @summary Upload a creator's profile picture or banner
 */
export const useCreatorsControllerUploadImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerUploadImage>>,
      TError,
      {
        creatorId: string;
        imageType: "profile" | "banner";
        data: BodyType<CreatorsControllerUploadImageBody>;
      },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerUploadImage>>,
  TError,
  {
    creatorId: string;
    imageType: "profile" | "banner";
    data: BodyType<CreatorsControllerUploadImageBody>;
  },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerUploadImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete a creator's profile picture or banner
 */
export const creatorsControllerRemoveImage = (
  creatorId: string,
  imageType: "profile" | "banner",
  options?: SecondParameter<typeof apiRequest>,
) => {
  return apiRequest<void>(
    { url: `/creators/${creatorId}/images/${imageType}`, method: "DELETE" },
    options,
  );
};

export const getCreatorsControllerRemoveImageMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof creatorsControllerRemoveImage>>,
    TError,
    { creatorId: string; imageType: "profile" | "banner" },
    TContext
  >;
  request?: SecondParameter<typeof apiRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof creatorsControllerRemoveImage>>,
  TError,
  { creatorId: string; imageType: "profile" | "banner" },
  TContext
> => {
  const mutationKey = ["creatorsControllerRemoveImage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof creatorsControllerRemoveImage>>,
    { creatorId: string; imageType: "profile" | "banner" }
  > = (props) => {
    const { creatorId, imageType } = props ?? {};

    return creatorsControllerRemoveImage(creatorId, imageType, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreatorsControllerRemoveImageMutationResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerRemoveImage>>
>;

export type CreatorsControllerRemoveImageMutationError = ErrorType<unknown>;

/**
 * @summary Delete a creator's profile picture or banner
 */
export const useCreatorsControllerRemoveImage = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof creatorsControllerRemoveImage>>,
      TError,
      { creatorId: string; imageType: "profile" | "banner" },
      TContext
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof creatorsControllerRemoveImage>>,
  TError,
  { creatorId: string; imageType: "profile" | "banner" },
  TContext
> => {
  const mutationOptions =
    getCreatorsControllerRemoveImageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get top creators by track type
 */
export const creatorsControllerTopCreators = (
  params?: CreatorsControllerTopCreatorsParams,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<CreatorsControllerTopCreators200>(
    { url: `/creators/top`, method: "GET", params, signal },
    options,
  );
};

export const getCreatorsControllerTopCreatorsQueryKey = (
  params?: CreatorsControllerTopCreatorsParams,
) => {
  return [`/creators/top`, ...(params ? [params] : [])] as const;
};

export const getCreatorsControllerTopCreatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerTopCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCreatorsControllerTopCreatorsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creatorsControllerTopCreators>>
  > = ({ signal }) =>
    creatorsControllerTopCreators(params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CreatorsControllerTopCreatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerTopCreators>>
>;
export type CreatorsControllerTopCreatorsQueryError = ErrorType<unknown>;

export function useCreatorsControllerTopCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | CreatorsControllerTopCreatorsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerTopCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCreatorsControllerTopCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerTopCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerTopCreators>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCreatorsControllerTopCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerTopCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get top creators by track type
 */

export function useCreatorsControllerTopCreators<
  TData = Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
  TError = ErrorType<unknown>,
>(
  params?: CreatorsControllerTopCreatorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerTopCreators>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCreatorsControllerTopCreatorsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the detail of a creator
 */
export const creatorsControllerDetailCreator = (
  creatorIdOrSlug: string,
  options?: SecondParameter<typeof apiRequest>,
  signal?: AbortSignal,
) => {
  return apiRequest<DetailCreatorDto>(
    { url: `/creators/${creatorIdOrSlug}`, method: "GET", signal },
    options,
  );
};

export const getCreatorsControllerDetailCreatorQueryKey = (
  creatorIdOrSlug?: string,
) => {
  return [`/creators/${creatorIdOrSlug}`] as const;
};

export const getCreatorsControllerDetailCreatorQueryOptions = <
  TData = Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
  TError = ErrorType<unknown>,
>(
  creatorIdOrSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getCreatorsControllerDetailCreatorQueryKey(creatorIdOrSlug);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof creatorsControllerDetailCreator>>
  > = ({ signal }) =>
    creatorsControllerDetailCreator(creatorIdOrSlug, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!creatorIdOrSlug,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type CreatorsControllerDetailCreatorQueryResult = NonNullable<
  Awaited<ReturnType<typeof creatorsControllerDetailCreator>>
>;
export type CreatorsControllerDetailCreatorQueryError = ErrorType<unknown>;

export function useCreatorsControllerDetailCreator<
  TData = Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
  TError = ErrorType<unknown>,
>(
  creatorIdOrSlug: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerDetailCreator>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData>;
};
export function useCreatorsControllerDetailCreator<
  TData = Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
  TError = ErrorType<unknown>,
>(
  creatorIdOrSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
          TError,
          Awaited<ReturnType<typeof creatorsControllerDetailCreator>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useCreatorsControllerDetailCreator<
  TData = Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
  TError = ErrorType<unknown>,
>(
  creatorIdOrSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get the detail of a creator
 */

export function useCreatorsControllerDetailCreator<
  TData = Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
  TError = ErrorType<unknown>,
>(
  creatorIdOrSlug: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof creatorsControllerDetailCreator>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof apiRequest>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getCreatorsControllerDetailCreatorQueryOptions(
    creatorIdOrSlug,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
